import React, { useCallback, useEffect } from 'react';
import { Form, Input, Button, Select, Row, Col, notification } from 'antd';
import { FormInstance } from 'antd/lib/form';
import {
  createContacts,
  tpContactsResponse,
  updateThirdPartyAddres,
  updateThirdPartyContact,
} from 'services/thirdParty';
import { useForm } from 'antd/lib/form/Form';
import FormInput from 'components/FormInput';
import address from 'components/address';
import ButtonLink from 'components/theme_components/ButtonLink';
import ParListSelect from 'components/ParListSelect';

export type ContactModalProps = {
  contacts?: tpContactsResponse;
  setVisible: (visible: boolean) => void;
  tpid: number;
  refetch?: () => void;
};

const ContactModal = ({
  contacts,
  setVisible,
  tpid,
  refetch,
}: ContactModalProps) => {
  const [form] = useForm();
  useEffect(() => {
    if (contacts) {
      form.setFieldsValue(contacts);
    } else {
      form.setFieldsValue(initialValue);
    }
  }, [form, contacts]);

  const formatPhoneNumber = (value: string): string => {
    const numbers = value.replace(/\D/g, '');
    return numbers.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
  };

  const handlePhoneChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string
  ) => {
    const formatted = formatPhoneNumber(e.target.value);
    form.setFieldsValue({ [fieldName]: formatted });
  };
  const onSave = (record: any) => {
    !contacts
      ? createContacts({
          tpContactRequest: { ...record, tpid },
          tpid: Number(tpid),
        }).then((response) => {
          if (response.code === '200') {
            notification.success({
              message: response.message,
            });
            setVisible(false);
            refetch && refetch();
          }
        })
      : updateThirdPartyContact({
          tpContactRequest: record,
          tpcontactid: contacts?.tpcontactid,
          tpid: contacts?.tpid,
        }).then((response) => {
          if (response.code === '200') {
            notification.success({
              message: response.message,
            });
            setVisible(false);
            refetch && refetch();
          }
        });
  };
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={(values) => {
        const record = {
          ...values,
          tpadrid: form.getFieldValue('listAdresses')?.tpadrid,
        };
        onSave(record);
      }}
    >
      <div style={{ padding: 10 }}>
        <Row gutter={[3, 3]} className="no-border-radius">
          <FormInput name="lastname" col md={24} className="btn-modal">
            <Input className="ut-input-modal" />
          </FormInput>

          <FormInput name="firstname" col md={24} className="btn-modal">
            <Input className="ut-input-modal" />
          </FormInput>

          <FormInput name="position" col md={24} className="btn-modal">
            <ParListSelect parcode="TPMANPOS" className="ut-input-modal" />
          </FormInput>

          <FormInput name="tel1" col md={24} className="btn-modal">
            <Input
              className="ut-input-modal"
              onChange={(e) => handlePhoneChange(e, 'tel1')}
            />
          </FormInput>

          <FormInput name="tel2" col md={24} className="btn-modal">
            <Input
              className="ut-input-modal"
              onChange={(e) => handlePhoneChange(e, 'tel2')}
            />
          </FormInput>

          <FormInput
            name="email"
            col
            md={24}
            className="btn-modal"
            rules={[
              
              { type: 'email', message: 'Please enter a valid email address!' },
            ]}
          >
            <Input className="ut-input-modal" />
          </FormInput>
        </Row>
        <Row justify={'end'} style={{ marginTop: 13 }}>
          <ButtonLink
            comcode="Annuler"
            className="ut-reset-btn"
            onClick={() => setVisible(false)}
          />
          <ButtonLink
            type="primary"
            comcode="Valider"
            htmlType="submit"
            className="ut-submit-btn"
            style={{ marginLeft: 10 }}
          />
        </Row>
      </div>
    </Form>
  );
};
const initialValue = {
  tpcontactid: 0,
  tpid: 0,
  firstname: '',
  lastname: '',
  position: '',
  tel1: '',
  tel2: '',
  email: '',
};
export default ContactModal;
